import script from "./GCS.vue?vue&type=script&setup=true&lang=js"
export * from "./GCS.vue?vue&type=script&setup=true&lang=js"

import "./GCS.vue?vue&type=style&index=0&id=c3398bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3398bf6"]])

export default __exports__